<mat-drawer-container class="sidenav-container" autosize>
  <mat-drawer #drawer class="cart-sidenav" position="end" mode="side">
    <div fxLayoutFlex="100" fxLayout="row" fxLayoutAlign="end center">
      <button
        mat-icon-button
        class="close-cart"
        (click)="drawer.toggle()">
        <mat-icon matTooltip="Fechar">
          close
        </mat-icon>
      </button>
    </div>
    <p class="cart-title">{{ 'new-order.cart-items' | translate }}</p>
    @if(cartItems.length === 0){
      <div class="empty-cart">{{ 'new-order.cart-empty' | translate }}</div>
    }
    @for(cartItem of cartItems; track cartItem.id){
      <div fxLayout="column" fxLayoutAlign="center center" class="item-cart">
        <div class="cart-text">
          #{{ cartItem.partNumber }} - {{ cartItem.description }} - {{ cartItem.manufacturer }}
        </div>
        <div fxLayout="row" fxLayoutAlign="space-evenly center">
          @if(cartItem.requestedQuantity < 2){
            <button mat-icon-button class="icons-cart" style="color: #B41E2A;" (click)="removeFromCart(cartItem)">
              <mat-icon>delete</mat-icon>
            </button>
          } @else {
            <button mat-icon-button class="icons-cart" (click)="decreaseQuantity(cartItem)">
              <mat-icon>remove</mat-icon>
            </button>
          }
          <mat-form-field appearance="outline" class="custom-form-field">
            <input
            matInput
            type="text"
            inputmode="numeric"
            [mask]="'0*'"
            min="1"
            [(ngModel)]="cartItem.requestedQuantity"
            (ngModelChange)="updateCartLocalStorage()"
            (blur)="validateQuantity(cartItem)"
            />
          </mat-form-field>
          <button mat-icon-button class="icons-cart" (click)="increaseQuantity(cartItem)">
            <mat-icon>add</mat-icon>
          </button>
        </div>
      </div>
    }
  </mat-drawer>

  <div class="page">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <h1 class="page-title-no-border">
        @if(orderId) {
          {{ 'general.edit-order' | translate:{ orderId: orderId, projectType: originalProjectType, projectDescription: originalProjectDescription } }}
        } @else {
          {{ counter > 0 ? ('new-order.request-new-order' | translate) : ('new-order.new-order-title' | translate) }}
        }
      </h1>
      @if(!drawer.opened){
        <button
        class="cart-button"
        mat-icon-button
        style="height: 60px; width: 60px;"
        [matBadge]="badgeDisplay"
        matBadgeSize="large"
        (click)="drawer.toggle()">
        <mat-icon matTooltip="{{ 'new-order.cart' | translate }}" style="color: #003369;">
          add_shopping_cart
        </mat-icon>
      </button>
    }
    </div>
    <div class="container-buttons">
      <button mat-flat-button class="text" [ngClass]="{'selected-button': selectedCategoryId === null}" (click)="selectedCategoryId = null; filterItems()">
        <mat-icon>apps</mat-icon>
        {{ 'new-order.all-categories' | translate }}
      </button>
      @for(category of categories; track category.id){
        <button mat-flat-button class="text" [ngClass]="{'selected-button': selectedCategoryId == category.id}" (click)="selectedCategoryId = category.id; filterItems()">
          <mat-icon>{{category.icon}}</mat-icon>{{ category.category }}
        </button>
      }
    </div>

    <div>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label class="text">{{ 'new-order.search-item' | translate }}</mat-label>
        <input
          matInput
          [(ngModel)]="searchQuery"
          (input)="filterItems()"
          placeholder="{{ 'new-order.search-placeholder' | translate }}" />
      </mat-form-field>
    </div>

    <div class="items">
      <div class="container-items" fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="1.875rem">
        @for(item of filteredItems; track item.id){
          <mat-card fxFlex="100" class="item-card">
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <div fxFlex="80" fxLayout="row" fxLayoutAlign="start center">
                <img
                  class="item-image"
                  [src]="item.pathImage || placeholderImage"
                  alt="{{ 'new-order.item-image-alt' | translate }}">
                <mat-card-content class="text">
                  @if(item.isKit){
                    {{ 'new-order.kit-label' | translate }} - {{ item.description }}
                  }@else {
                    #{{ item.partNumber }} - {{ item.description }} - {{ item.manufacturer }}
                  }
                </mat-card-content>
              </div>

              @if(item.isKit){
                <button mat-icon-button (click)="toggleKit(item)">
                  <mat-icon>
                    {{ isKitExpanded(item) ? 'arrow_drop_up' : 'arrow_drop_down' }}
                  </mat-icon>
                </button>
              }
              <button
                mat-flat-button
                class="add-to-cart-button"
                (click)="addToCart(item)"
                fxFlex="20">
                <mat-icon style="color: #072B52; font-weight: 500; font-size: larger;">
                  add_shopping_cart
                </mat-icon>
                <span class="add-to-cart">
                   {{ 'new-order.add-to-cart' | translate }}
                </span>
              </button>
            </div>

            @if(item.isKit && isKitExpanded(item)){
              <div class="kit-items-container" fxLayout="column" fxLayoutGap="4px">
                <div class="kit-header text">{{ 'new-order.kit-items' | translate }}</div>
                @for(kitItem of item.kit?.items; track kitItem.id){
                  <div class="kit-item" fxLayout="row" fxLayoutAlign="start center">
                    <mat-card-content class="subtext">
                      #{{ kitItem.partNumber }} - {{ kitItem.description }} - {{ kitItem.manufacturer }}
                    </mat-card-content>
                  </div>
                }
              </div>
            }
          </mat-card>
        }
      </div>
      @if(newOrderItems.length < totalElements){
        <div class="load-more-container" fxLayout="row" fxLayoutAlign="start center" style="margin-top: 1rem;">
          <button mat-raised-button style="background-color: #0099da33; color: #003369;" (click)="loadMoreItems()">
            {{'new-order.load-more-items' | translate}}
          </button>
        </div>
      }
    </div>
  </div>
</mat-drawer-container>
<app-breadcrumbs [breadcrumbsData]="breadcrumbsData"></app-breadcrumbs>
